export const CATEGORY_HOME_ID = 'CTGR_00001' // 카테고리 홈
export const CATEGORY_BUNDLE_HOME_ID = 'CTGR_00840' // 묶음상품홈
